import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { AppLoginMFARegistrationContainerModel } from "../../../../../models/aggregates/app-login/app_login_mfa_registration-container.model";
import { HttpClient } from "@angular/common/http";
import { Core2Config } from "../shared/core2Config";

@Injectable({ providedIn: "root" })
export class AppLoginMFARegistrationService extends BaseApiTemplateService<AppLoginMFARegistrationContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-login-mfa/registration/backoffice-ep";
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-login-mfa/registration/backoffice-ep";
    this.httpClient = http;
  }
}